import React, {useEffect, useRef, useState} from 'react';
import maCateImg from "../../assets/img/m-a-cate.png";
import '../../css/web/AdminTaxPg.css';
import '../../css/DarkMode.css';
import {useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import commonClose from "../../assets/img/commonClose.png";
import taxExcel from '../../assets/motion/taxExcel.json'
import Lottie from "lottie-react";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";
import commonPaying from "../../assets/motion/commonPaying.json";
import AdminTaxListModal from "../../components/web/modal/AdminTaxListModal";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import * as ExcelJS from "exceljs";


function AdminTaxPg() {

    const navigate = useNavigate();

    const [tab, setTab] = useState("VAT");

    const handleCategoryClick = (category) => {
        setTab(category);
    };


    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    // 날짜 포맷 함수
    const formatDateString = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // ✅ 초기 렌더링 시: 오늘 기준으로 endDate, startDate 설정
    useEffect(() => {
        const today = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(today.getMonth() - 3);

        setEndDate(formatDateString(today));
        setStartDate(formatDateString(threeMonthsAgo));
    }, []);

    // ✅ endDate 변경 시마다: 해당 날짜 기준으로 startDate 재설정
    useEffect(() => {
        if (!endDate) return;

        const newEndDate = new Date(endDate);
        const newStartDate = new Date(newEndDate);
        newStartDate.setMonth(newEndDate.getMonth() - 3);

        setStartDate(formatDateString(newStartDate));
    }, [endDate]);

    const startHandle = (e) => {
        setStartDate(e.target.value);
    };

    const endHandle = (e) => {
        setEndDate(e.target.value);
    };


    const [selectedBtLoading, setSelectedBtLoading] = useState(false);
    const [selectedBtDisabled, setSelectedBtDisabled] = useState(false);
    const [data, setData] = useState([]);

    const formattedStartDate = startDate.replace(/-/g, '');
    const formattedEndDate = endDate.replace(/-/g, '');

    const [pt1Data, setPt1Data] = useState([]);
    const [pt2Data, setPt2Data] = useState([]);

    // 유저 출고박스 리스트팝업 및 출력
    const [pt1DataShow, setPt1DataShow] = useState(false); // 팝업
    const [pt1DataPrint, setPt1DataPrint] = useState(false); // 출력
    const [uploadFormShow, setUploadFormShow] = useState(false); // 업로드폼 Show
    const [nonData, setNonData] = useState(false);

    const selectedTaxData = (() => {
        setSelectedBtLoading(true);
        setSelectedBtDisabled(true);
        try {
            axios({
                method: 'get',
                url: '/order/selectedTaxData/',
                params: {
                    startDate: formattedStartDate,
                    endDate: formattedEndDate
                }
            })
                .then((response) => {
                    const data = response.data || [];
                    const pt1Items = data.filter(item => item.payType === 'PT1');
                    const pt2Items = data.filter(item => item.payType === 'PT2');
                    setPt1Data(pt1Items.sort((a, b) => b.seqNum - a.seqNum));
                    setPt2Data(pt2Items.sort((a, b) => b.seqNum - a.seqNum));

                    // ✅ Ems 가격 계산
                    const emsShipSum = pt1Items.filter(item => ['D02', 'D13', 'D15'].includes(item.dvType))
                        .reduce((sum, item) => sum + (item.ttShipExpense || 0), 0);
                    const emsEtcSum = pt2Items.filter(item => item.etcPriceNm?.includes('Add missing Post-Office') ||
                        item.etcPriceNm?.includes('Add missing K-Packet'))
                        .reduce((sum, item) => sum + (item.ttEtcPrice || 0), 0);
                    setTtEmsPrice(emsShipSum + emsEtcSum);

                    // ✅ FedEx 가격 계산
                    const fedexShipSum = pt1Items.filter(item => ['D01', 'D16'].includes(item.dvType))
                        .reduce((sum, item) => sum + (item.ttShipExpense || 0), 0);
                    const fedexEtcSum = pt2Items.filter(item => item.etcPriceNm?.includes('Add missing FedEx'))
                        .reduce((sum, item) => sum + (item.ttEtcPrice || 0), 0);
                    setTtFedexPrice(fedexShipSum + fedexEtcSum);

                    // ✅ UPS 가격 계산
                    const upsShipSum = pt1Items.filter(item => ['D11', 'D17'].includes(item.dvType))
                        .reduce((sum, item) => sum + (item.ttShipExpense || 0), 0);
                    const upsEtcSum = pt2Items.filter(item => item.etcPriceNm?.includes('Add missing UPS'))
                        .reduce((sum, item) => sum + (item.ttEtcPrice || 0), 0);
                    setTtUpsPrice(upsShipSum + upsEtcSum);

                    // ✅ 구매대행 & 배송대행 국내배송수수료 가격 계산
                    const domesticDeliveryEtcSum = pt2Items.filter(item => item.etcFeeNm?.includes('Add missing Domestic-Delivery'))
                        .reduce((sum, item) => sum + (item.etcFee || 0), 0);
                    setTtDomesticFee(domesticDeliveryEtcSum);

                    if (pt1Items.length > 0) {
                        setPt1DataShow(true);
                    } else {
                        setNonData(true);
                    }

                    // 기간 안에 해당하는 적립금 사용내역도 별도조회
                    selectedTaxUsePoint();

                    // 각 수수료 총합 계산
                    calculateTotalFee(pt2Items);

                })
        } catch (error) {
            console.log("세무데이터 조회오류");
        } finally {
            setSelectedBtLoading(false);
            setSelectedBtDisabled(false);
        }
    })

    const calculateTotalFee = (pt2Items) => {
        const deliveryFeeSum = pt2Items.reduce((sum, item) => sum + (item.deliveryFee || 0), 0); // 배송대행수수료
        const repackFeeSum   = pt2Items.reduce((sum, item) => sum + (item.repackFee || 0), 0); // 재포장수수료
        const agencyFeeSum   = pt2Items.reduce((sum, item) => sum + (item.agencyFee || 0), 0); // 대행수수료
        const comprFeeSum    = pt2Items.reduce((sum, item) => sum + (item.comprFee || 0), 0); // 압축팩수수료
        const etcFeeSum      = pt2Items.reduce((sum, item) => sum + (item.etcFee || 0), 0); // 기타수수료
        setDeliveryFee(deliveryFeeSum);
        setRepackFee(repackFeeSum);
        setAgencyFee(agencyFeeSum);
        setComprFee(comprFeeSum);
        setEtcFee(etcFeeSum);
        console.log("pt2Items : ", pt2Items)
    }

    const [usePointList, setUsePointList] = useState([]);
    const [totalUsePoint, setTotalUsePoint] = useState(0);
    const [usePointFile, setUsePointFile] = useState(null); // 파일 1개만 저장
    const selectedTaxUsePoint = () => {
        axios({
            method: 'get',
            url: '/member/selectedTaxUsePoint',
            params: {
                startDate: formattedStartDate,
                endDate: formattedEndDate
            }
        })
            .then((res) => {
                const data = res.data.sort((a, b) => b.seqNum - a.seqNum);

                // ① 총합 계산
                const total = data.reduce((acc, item) => acc + (item.ptPrice || 0), 0);
                setTotalUsePoint(total);

                // ② 시트 데이터 구성 (번호 / 날짜 / 성함 / 구분 / 사용적립금)
                const sheetData = [
                    ['번호', '날짜', '성함', '구분', '사용적립금'], // A행 헤더
                    ...data.map((item, index) => [
                        index + 1,
                        formatDate(item.regDate),        // "2025-01-31"
                        item.memberDTO?.userName || '',
                        '사용',
                        item.ptPrice || 0  // 숫자형 유지 (toLocaleString 제거)
                    ])
                ];

                // ③ 엑셀 워크북 생성
                const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, '적립금사용내역');

                // ④ 엑셀 Blob 생성 및 usePointFile에 저장
                const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const excelBlob = new Blob([wbout], { type: 'application/octet-stream' });
                setUsePointFile(excelBlob); // 필요한 경우 URL.createObjectURL(blob)로 다운로드 가능

                // 기존 목록도 상태 저장
                setUsePointList(data);
            })
            .catch((error) => {
                console.log("적립금 사용내역 조회실패 : ", error);
            });
    };

    // 날짜 포맷 함수 (yyyymmdd → yyyy-mm-dd)
    const formatDate = (yyyymmdd) => {
        if (!yyyymmdd || yyyymmdd.length !== 8) return '';
        return `${yyyymmdd.slice(0, 4)}-${yyyymmdd.slice(4, 6)}-${yyyymmdd.slice(6, 8)}`;
    };

    const closeNonDataPopup = () => {
        setNonData(false);
    }

    const closePt1DataPopup = () => {
        setPt1DataShow(false);
    }

    const closeFedexUnMatchShow = () => {
        setFedexUnMatchShow(false);
    }

    const closeUpsUnMatchShow = () => {
        setUpsUnMatchShow(false);
    }

    const completeFilter = (filterData) => {
        // 여기서 pt1Data를 필터된 data로 갈아끼우고 length > 0이면 업로드폼 열기
        setPt1DataShow(false);
        setPt1DataPrint(true);
        setPt1Data(filterData);
        if (filterData.length > 0) {
            setUploadFormShow(true);
        } else {
            setNonData(true);
        }
    }

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    // 업로드 엑셀내역(거래처)
    const [emsFile, setEmsFile] = useState(null); // EMS(+프리미엄, +K-Packet) 소포수령증
    const [emsPaybackFile, setEmsPaybackFile] = useState(null); // EMS 페이백
    const [fedexFile, setFedexFile] = useState(null); // 페덱스 청구서
    const [upsFile, setUpsFile] = useState(null); // UPS 청구서
    const [orderCardFile, setOrderCardFile] = useState(null); // 구매카드내역서
    const [overCardFile, setOverCardFile] = useState(null); // 해외카드내역서
    const [orderLogFile, setOrderLogFile] = useState(null); // 구매일지

    // 업로드 엑셀내역(구글드라이브)
    const [transferFee, setTransferFee] = useState(0); // 이체대행 7% 수수료
    const [domesticFee, setDomesticFee] = useState(0); // 국내배송(구매분)/결제대행(무형물) 7% 수수료
    const [offlineFee, setOfflineFee] = useState(0); // 오프라인 구매대행 수수료

    // ttPrice(기타비용의 add missing 포함)
    const [ttEmsPrice, setTtEmsPrice] = useState(0);
    const [ttFedexPrice, setTtFedexPrice] = useState(0);
    const [ttUpsPrice, setTtUpsPrice] = useState(0);
    const [ttDomesticFee, setTtDomesticFee] = useState(0); // 구매&배송대행 국내(한국)배송 수수료

    // 특송(FedEx/UPS) 매칭불가 리스트팝업 Show
    const [fedexUnMatchShow, setFedexUnMatchShow] = useState(false);
    const [fedexUnMatchList, setFedexUnMatchList] = useState([]);
    const [upsUnMatchShow, setUpsUnMatchShow] = useState(false);
    const [upsUnMatchList, setUpsUnMatchList] = useState([]);

    // 업로드폼 전환상태(업로드 시 이미지 -> 청구서총금액/최종수수료 출력)
    const [emsUploadShow, setEmsUploadShow] = useState(false);
    const [emsPaybackUploadShow, setEmsPaybackUploadShow] = useState(false);
    const [fedexUploadShow, setFedexUploadShow] = useState(false);
    const [upsUploadShow, setUpsUploadShow] = useState(false);
    const [orderCardUploadShow, setOrderCardUploadShow] = useState(false);
    const [overCardUploadShow, setOverCardUploadShow] = useState(false);
    const [orderLogUploadShow, setOrderLogUploadShow] = useState(false);

    // 청구서 총금액
    const [ttEmsFilePrice, setTtEmsFilePrice] = useState(0);
    const [ttSPackFilePrice, setTtSPackFilePrice] = useState(0); // 엑셀없음(노필요)
    const [ttSeaParcelFilePrice, setTtSeaParcelFilePrice] = useState(0); // 엑셀없음(노필요)
    const [ttFedexFilePrice, setTtFedexFilePrice] = useState(0);
    const [ttUpsFilePrice, setTtUpsFilePrice] = useState(0);
    const [ttOrderCardPrice, setTtOrderCardPrice] = useState(0);
    const [ttDomesticOrderCardPrice, setTtDomesticOrderCardPrice] = useState(0);
    const [ttOverCardPrice, setTtOverCardPrice] = useState(0);
    const [ttOrderRecordPrice, setTtOrderRecordPrice] = useState(0); // 구매일지 총금액(노필요)

    // 최종수수료 = ttPrice(+기타비용의 add missing) - 청구서 총금액
    const [emsFee, setEmsFee] = useState(0); // EMS(+프리미엄, +K-Packet) 페이백
    const [sPackQy, setSPackQy] = useState(0); // S-Packet 개수
    const [sPackFee, setSPackFee] = useState(0); // S-Packet 수수료 ★개수 입력하면 *5000
    const [seaFee, setSeaFee] = useState(0); // 선편 수수료 ★수수료만 입력
    const [fedexFee, setFedexFee] = useState(0); // FedEx 수수료
    const [upsFee, setUpsFee] = useState(0); // UPS 수수료
    const [deliveryFee, setDeliveryFee] = useState(0); // 배송대행수수료
    const [repackFee, setRepackFee] = useState(0); // 재포장수수료
    const [agencyFee, setAgencyFee] = useState(0); // 대행수수료
    const [comprFee, setComprFee] = useState(0); // 압축팩수수료
    const [etcFee, setEtcFee] = useState(0); // 기타수수료

    const [fedexFileWaybillList, setFedexFileWaybillList] = useState([]); // pt1Data와 업로드엑셀의 매칭 운송장번호 리스트
    const [fedexFileAmountList, setFedexFileAmountList] = useState([]); // 매칭된 행의 차액금이 -인 데이터 리스트
    const [upsFileWaybillList, setUpsFileWaybillList] = useState([]); // pt1Data와 업로드엑셀의 매칭운송장번호 리스트
    const [upsFileAmountList, setUpsFileAmountList] = useState([]); // 매칭된 행의 차액금이 -인 데이터 리스트

    const fileInputRef = useRef(null);
    const [uploadType, setUploadType] = useState('');

    const handleDashboardClick = (type) => {
        setUploadType(type);
        // 이 시점에 fileInputRef.current는 렌더링된 input 요소를 가리켜야 합니다.
        if (fileInputRef.current) {
            fileInputRef.current.click();
        } else {
            console.error("파일 입력(ref)이 존재하지 않습니다.");
        }
    };

    const sampleUps = pt1Data.find(v => ['D11','D17'].includes(v.dvType));
    console.log('UPS sample shipPrice:', sampleUps?.shipInfoDTO?.shipPrice);
    console.log('UPS sample ttShipExpense:', sampleUps?.ttShipExpense);
    console.log('UPS sample shipInfoDTO:', sampleUps?.shipInfoDTO);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log(`[${uploadType}] 파일 업로드 시작:`, file.name);

        try {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data);
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, {header: 1});

            switch (uploadType) {
                case 'EMS_BILL':
                    setEmsFile(file);
                    setTtEmsFilePrice(calculateSumFromColumn(json, 8, 1));
                    setEmsUploadShow(true);
                    break;
                case 'EMS_PAYBACK':
                    setEmsPaybackFile(file);
                    setEmsFee(calculateSumFromColumn(json, 6, 1));
                    setEmsPaybackUploadShow(true);
                    break;
                case 'FEDEX_BILL':
                    setFedexFile(file);

                    // ✅ 엑셀 해외배송료 청구료(AR열) 총합 계산
                    const fedexSum = calculateSumByColumnLetter(worksheet, 'BN', 2); // AR2열 2행부터(청구배송료)
                    setTtFedexFilePrice(fedexSum);
                    // 최종수수료 = (DB배송료 - 청구서배송료)
                    if (ttFedexPrice > 0 && fedexSum > 0) {
                        setFedexFee(ttFedexPrice - fedexSum);
                    }
                    setFedexUploadShow(true);

                    const fedexAggMap = new Map(); // 운송장번호를 Key로 데이터를 합치기 위한 Map

                    // 엑셀 시트의 전체범위 조회
                    const ref_fedex = worksheet['!ref'];
                    if (!ref_fedex) {
                        console.error("FedEx 시트가 비어있거나 '!ref' 속성이 없습니다.");
                        break;
                    }
                    const range_fedex = ref_fedex.split(':');
                    const endRowMatch_fedex = range_fedex[1].match(/(\d+)$/);
                    if (!endRowMatch_fedex) {
                        console.error("FedEx 시트의 마지막 행 파싱불가");
                        break;
                    }
                    const endRow_fedex = parseInt(endRowMatch_fedex[1], 10);

                    // while(true)로 중간마다 비어있어도 마지막까지 실행
                    for (let fRow = 2; fRow <= endRow_fedex; fRow++) {
                        const waybillCell = worksheet[`Q${fRow}`]; // 운송장번호 (Q)

                        // 운송장 번호가 없는 '빈 행'이면 건너띄고 다음추출
                        if (!waybillCell || !waybillCell.v) {
                            continue;
                        }

                        // const waybill = waybillCell.v ?? '';
                        const waybill = String(waybillCell.v || '').trim();

                        // 청구배송료 (BN)
                        const amountCell = worksheet[`BN${fRow}`];
                        const rawAmount = String(amountCell?.v ?? '').replace(/,/g, '');
                        const amount = parseFloat(rawAmount) || 0;

                        // 청구서 유형: B열 (운송 vs 관세/세금)
                        const typeCell = worksheet[`B${fRow}`];
                        const typeValue = String(typeCell?.v ?? '');

                        // 박스번호 (S)
                        const boxNum = worksheet[`S${fRow}`]?.v ?? '';
                        // 성함 (AW)
                        const name = worksheet[`AW${fRow}`]?.v ?? '';
                        // 배송사 타입 (AD)
                        const shipCoType = worksheet[`AD${fRow}`]?.v ?? '';
                        const shipCo = (shipCoType === 'EC' || shipCoType === 'IE') ? 'FedEx-E' : 'FedEx';

                        // Map에 해당 운송장번호 데이터가 없으면 초기화
                        if (!fedexAggMap.has(waybill)) {
                            fedexAggMap.set(waybill, {
                                waybill: waybill,
                                amount: 0, // 금액 누적을 위해 0으로 시작
                                boxNum: '',
                                name: '',
                                shipCo: 'FedEx'
                            });
                        }

                        const currentData = fedexAggMap.get(waybill);

                        // 금액 합산 (운송료 + 관부가세)
                        currentData.amount += amount;

                        // '운송' 행에 보통 정확한 박스번호/이름이 있으므로 '운송' 타입일 때 정보를 우선 저장
                        // 혹은 기존 데이터가 비어있으면 현재 행 데이터로 채움
                        if (typeValue.includes('운송') || !currentData.boxNum) {
                            currentData.boxNum = boxNum || currentData.boxNum;
                            currentData.name = name || currentData.name;
                            currentData.shipCo = shipCo;
                        }
                    }

                    // ✅ Map의 Values를 배열로 변환하여 기존 로직(fedexExcelData)에 할당
                    const fedexExcelData = Array.from(fedexAggMap.values());
                    // ✅ 엑셀 데이터를 Map으로 변환(더 빠른 조회)
                    const fedexExcelMap = new Map(fedexExcelData.map(item => [item.waybill, item]));
                    // ✅ 매칭불가 리스트 생성
                    const fedexUnMatchedList = [];

                    // DB 데이터(pt1Data)와 비교하여 '금액 불일치' 조회
                    pt1Data.forEach(item => {
                        if (!['D01', 'D16'].includes(item.dvType)) return; // FedEx 데이터만 필터링

                        const dbWaybill = item.shipInfoDTO.outWayNum;
                        const excelItem = fedexExcelMap.get(dbWaybill);

                        if (excelItem) {
                            // 엑셀에 해당 운송장번호가 존재함
                            const dbPrice = item.shipInfoDTO.shipPrice || 0;
                            const excelPrice = excelItem.amount;
                            const diff = dbPrice - excelPrice;

                            if (diff < 0) {
                                // 금액이 다른 경우 (엑셀 > DB)
                                fedexUnMatchedList.push({
                                    isDbEntry: true, // DB 기반 데이터
                                    orderNumber: item.orderdtDTO.orderNumber, // 링크용
                                    boxNum: item.orderdtDTO.orderNumber + "-" + item.shipInfoDTO.boxNum,
                                    name: item.orderdtDTO.regNm,
                                    shipCo: convertToShipco(item.dvType),
                                    expectedPrice: dbPrice,
                                    actualPrice: excelPrice,
                                    diff: diff,
                                    waybill: dbWaybill
                                });
                            }

                            // [중요] 비교 완료된 항목은 Map에서 삭제
                            fedexExcelMap.delete(dbWaybill);

                        } else {
                            // 엑셀에 DB 운송장번호가 없는 경우 (요구사항 외 - 일단 무시)
                            console.log("엑셀의 운송장번호가 데이터베이스에 존재하지 않습니다");
                        }
                    });

                    // 발송데이터가 없지만 엑셀 청구서로 청구된 데이터
                    fedexExcelMap.forEach((excelItem, waybill) => {
                        fedexUnMatchedList.push({
                            isDbEntry: false, // 미배송 청구데이터(DB에 누락)
                            orderNumber: excelItem.boxNum, // 엑셀 S열
                            boxNum: excelItem.boxNum, // 엑셀 S열
                            name: excelItem.name,     // 엑셀 AW열
                            shipCo: excelItem.shipCo,   // 엑셀 AD열
                            expectedPrice: 0,           // 엑셀엔 있지만 DB에는 없는 잘못된 청구료(예상배송료 0원 고정)
                            actualPrice: excelItem.amount, // 엑셀 BN열(청구배송료)
                            diff: 0 - excelItem.amount,
                            waybill: waybill          // 엑셀 Q열
                        });
                    });

                    // 매칭불가 데이터가 1개 이상이면 저장
                    if (fedexUnMatchedList && fedexUnMatchedList.length > 0) {
                        // [수정] 정렬: DB누락(isDbEntry: false) 데이터를 위로, 그다음 박스번호 순 (선택사항)
                        fedexUnMatchedList.sort((a, b) => {
                            if (a.isDbEntry !== b.isDbEntry) {
                                // a가 true (DB데이터)면 -1 (위로)
                                // a가 false (엑셀데이터)면 1 (아래로)
                                return a.isDbEntry ? -1 : 1;
                            }
                            // boxNum이 null이거나 undefined일 수 있는 경우 대비
                            const boxA = String(a.boxNum || '');
                            const boxB = String(b.boxNum || '');
                            return boxA.localeCompare(boxB);
                        });

                        setFedexUnMatchList(fedexUnMatchedList);
                        setFedexUnMatchShow(true); // setTimeout 제거 (즉시 표시)
                    }

                    break;
                case 'UPS_BILL':
                    setUpsFile(file);

                    // ✅ 엑셀 해외배송료 청구료(AR열) 총합 계산
                    const upsSum = calculateSumByColumnLetter(worksheet, 'BA', 1); // BA 1열(청구배송료)
                    setTtUpsFilePrice(upsSum);
                    // 최종수수료 = (DB배송료 - 청구서배송료)
                    if (ttUpsPrice > 0 && upsSum > 0) {
                        setUpsFee(ttUpsPrice - upsSum);
                    }
                    setUpsUploadShow(true);

                    // ✅ 운송장번호를 Key로 데이터를 합치기 위한 Map
                    const upsAggMap = new Map();

                    // 엑셀 시트의 전체범위 조회
                    const ref_ups = worksheet['!ref'];
                    if (!ref_ups) {
                        console.error("UPS 시트가 비어있거나 '!ref' 속성이 없습니다.");
                        break;
                    }
                    const range_ups = ref_ups.split(':');
                    const endRowMatch_ups = range_ups[1].match(/(\d+)$/);
                    if (!endRowMatch_ups) {
                        console.error("UPS 시트의 마지막 행 파싱불가");
                        break;
                    }
                    const endRow_ups = parseInt(endRowMatch_ups[1], 10);

                    // while(true)로 중간마다 비어있어도 마지막까지 실행
                    for (let fRow = 2; fRow <= endRow_ups; fRow++) {
                        const waybillCell = worksheet[`N${fRow}`]; // 운송장번호 (N)

                        // 운송장 번호가 없는 '빈 행'이면 건너띄고 다음추출
                        if (!waybillCell || !waybillCell.v) {
                            continue;
                        }

                        const waybill = waybillCell.v ?? '';

                        // 청구배송료 (BA)
                        const amountCell = worksheet[`BA${fRow}`];
                        const rawAmount = String(amountCell?.v ?? '').replace(/,/g, '');
                        const amount = parseFloat(rawAmount) || 0;

                        // 배송사 타입 (AT) - 문자열 처리
                        const typeCell = worksheet[`AT${fRow}`];
                        const typeValue = String(typeCell?.v ?? '');

                        // 박스번호 (P), 성함 (BW)
                        const boxNum = worksheet[`P${fRow}`]?.v ?? '';
                        const name = worksheet[`BW${fRow}`]?.v ?? '';

                        // ✅ Map에 해당 운송장번호가 없으면 초기화 (첫 번째 행 기준 설정)
                        if (!upsAggMap.has(waybill)) {
                            let shipCo = 'UPS';
                            if (typeValue.toLowerCase().includes('expedited')) {
                                shipCo = 'UPS-E';
                            } else if (typeValue.includes("Saver")) { shipCo = 'UPS'; }

                            upsAggMap.set(waybill, {
                                waybill: waybill,
                                amount: 0, // 합산을 위해 0으로 시작
                                boxNum: boxNum, // 첫 행의 박스번호 사용
                                name: name,     // 첫 행의 이름 사용
                                shipCo: shipCo  // 첫 행 기준 결정된 타입
                            });
                        }

                        // ✅ [개선 1] 금액 합산 (기존 값 + 현재 행의 금액)
                        const currentData = upsAggMap.get(waybill);
                        currentData.amount += amount;
                    }

                    // ✅ Map의 Values를 배열로 변환하여 upsExcelData 생성 (중복 제거됨)
                    const upsExcelData = Array.from(upsAggMap.values());

                    // ✅ 이후 비교 로직을 위한 Map 생성 (빠른 조회를 위함)
                    const upsExcelMap = new Map(upsExcelData.map(item => [item.waybill, item]));

                    // ✅ 매칭불가 리스트 생성 및 비교 로직 (기존 유지)
                    const upsUnMatchedList = [];

                    // DB 데이터(pt1Data)와 비교하여 '금액 불일치' 조회
                    pt1Data.forEach(item => {
                        if (!['D11', 'D17'].includes(item.dvType)) return; // UPS 데이터만 필터링

                        const dbWaybill = item.shipInfoDTO.outWayNum;
                        const excelItem = upsExcelMap.get(dbWaybill);

                        if (excelItem) {
                            // 엑셀에 해당 운송장번호가 존재함
                            const dbPrice = item.shipInfoDTO.shipPrice || 0;
                            const excelPrice = excelItem.amount;
                            const diff = dbPrice - excelPrice;

                            if (diff < 0) {
                                // 금액이 다른 경우 (엑셀 > DB)
                                upsUnMatchedList.push({
                                    isDbEntry: true, // DB 기반 데이터
                                    orderNumber: item.orderdtDTO.orderNumber, // 링크용
                                    boxNum: item.orderdtDTO.orderNumber + "-" + item.shipInfoDTO.boxNum,
                                    name: item.orderdtDTO.regNm,
                                    shipCo: convertToShipco(item.dvType),
                                    expectedPrice: dbPrice,
                                    actualPrice: excelPrice,
                                    diff: diff,
                                    waybill: dbWaybill
                                });
                            }

                            // [중요] 비교 완료된 항목은 Map에서 삭제
                            upsExcelMap.delete(dbWaybill);

                        } else {
                            // 엑셀에 DB 운송장번호가 없는 경우 (요구사항 외 - 일단 무시)
                            console.log("엑셀의 운송장번호가 데이터베이스에 존재하지 않습니다");
                        }
                    });

                    // 발송데이터가 없지만 엑셀 청구서로 청구된 데이터
                    upsExcelMap.forEach((excelItem, waybill) => {
                        upsUnMatchedList.push({
                            isDbEntry: false, // 미배송 청구데이터(DB에 누락)
                            orderNumber: excelItem.boxNum, // 엑셀 P열
                            boxNum: excelItem.boxNum, // 엑셀 P열
                            name: excelItem.name,     // 엑셀 BW열
                            shipCo: excelItem.shipCo,   // 엑셀 AT열 기준 계산값
                            expectedPrice: 0,           // 엑셀엔 있지만 DB에는 없는 잘못된 청구료(예상배송료 0원 고정)
                            actualPrice: excelItem.amount, // 엑셀 BN열(청구배송료/합산된금액)
                            diff: 0 - excelItem.amount,
                            waybill: waybill          // 엑셀 N열
                        });
                    });

                    // 매칭불가 데이터가 1개 이상이면 저장
                    if (upsUnMatchedList && upsUnMatchedList.length > 0) {
                        // 정렬: DB누락(isDbEntry: false) 데이터를 위로, 그다음 박스번호 순 (선택사항)
                        upsUnMatchedList.sort((a, b) => {
                            if (a.isDbEntry !== b.isDbEntry) {
                                // a가 true (DB데이터)면 -1 (위로)
                                // a가 false (엑셀데이터)면 1 (아래로)
                                return a.isDbEntry ? -1 : 1;
                            }
                            // boxNum이 null이거나 undefined일 수 있는 경우 대비
                            const boxA = String(a.boxNum || '');
                            const boxB = String(b.boxNum || '');
                            return boxA.localeCompare(boxB);
                        });

                        setUpsUnMatchList(upsUnMatchedList);
                        setUpsUnMatchShow(true); // setTimeout 제거 (즉시 표시)
                    }

                    break;
                case 'ORDER_CARD': // 구매카드내역서
                    setOrderCardFile(file);
                    // 조건 1: 9행부터 시작 (Index 8)
                    // 조건 2: P(15), Q(16), R(17), S(18) 열 합산
                    const orderCardSum = sumVisibleRowsByCols(worksheet, 9, ['P', 'Q', 'R', 'S']);
                    console.log("구매카드 합산금액:", orderCardSum);
                    setTtOrderCardPrice(orderCardSum);
                    setOrderCardUploadShow(true);
                    break;
                case 'OVER_CARD': // 해외카드내역서
                    setOverCardFile(file);
                    // 조건 1: 14행부터 시작 (Index 13)
                    // 조건 2: P(15), Q(16), R(17), S(18) 열 합산
                    const overCardSum = sumVisibleRowsByCols(worksheet, 14, ['P', 'Q', 'R', 'S']);
                    setTtOverCardPrice(overCardSum);
                    setOverCardUploadShow(true);
                    break;
                case 'ORDER_LOG': // 구매일지
                    setOrderLogFile(file);

                    // 날짜 상태값이 존재하는지 확인 (없으면 기본값 또는 에러 처리 필요할 수 있음)
                    if (!formattedStartDate || !formattedEndDate) {
                        alert("집계할 날짜 범위를 먼저 선택해주세요.");
                        return;
                    }

                    const {
                        newTransferFee,
                        newDomesticFee,
                        newOfflineFee,
                        domesticOrderCardSum
                    } = calculateOrderLogFromWorkbook(workbook, formattedStartDate, formattedEndDate);

                    setTransferFee(newTransferFee);
                    setDomesticFee(newDomesticFee);
                    setOfflineFee(newOfflineFee);
                    setTtDomesticOrderCardPrice(domesticOrderCardSum);
                    setOrderLogUploadShow(true);
                    break;
                default:
                    console.log("알 수 없는 업로드 타입입니다.");
            }
        } catch (error) {
            console.error("파일 처리 중 오류:", error);
            alert("엑셀 파일을 처리하는 데 실패했습니다. 파일 형식을 확인해주세요.");
        }

        e.target.value = null;
    };

    const clearUploadForm = (form) => {
        if (form === "EMS_BILL") {
            setEmsFile(null);
            setTtEmsFilePrice(0);
            setEmsUploadShow(false);
        } else if (form === "EMS_PAYBACK") {
            setEmsPaybackFile(null);
            setEmsFee(0);
            setEmsPaybackUploadShow(false);
        } else if (form === "FEDEX_BILL") {
            setTtFedexFilePrice(0);
            setFedexFee(0);
            setFedexUploadShow(false);
            setFedexFileWaybillList([]);
            setFedexFileAmountList([]);
            setFedexFileAmountList([]);
        } else if (form === "UPS_BILL") {
            setTtUpsFilePrice(0);
            setUpsFee(0);
            setUpsUploadShow(false);
            setUpsFileWaybillList([]);
            setUpsFileAmountList([]);
            setUpsFileAmountList([]);
        } else if (form === "ORDER_CARD") {
            setOrderCardFile(null);
            setTtOrderCardPrice(0);
            setOrderCardUploadShow(false);
        } else if (form === "OVER_CARD") {
            setOverCardFile(null);
            setTtOverCardPrice(0);
            setOverCardUploadShow(false);
        } else if (form === "ORDER_LOG") {
            setTransferFee(0);
            setDomesticFee(0);
            setOfflineFee(0);
            setTtDomesticOrderCardPrice(0);
            setOrderLogUploadShow(false);
        }
    }

    const calculateSumByColumnLetter = (worksheet, columnLetter, startRow = 2) => {
        let sum = 0;
        let row = startRow;
        while (true) {
            const cellAddress = `${columnLetter}${row}`;
            const cell = worksheet[cellAddress];
            if (!cell) break;

            const rawValue = String(cell.v).replace(/,/g, '');
            const value = parseFloat(rawValue);

            if (!isNaN(value)) sum += value;
            row++;
        }
        return sum;
    };

    // 특정 행/열 총합계산
    const calculateSumFromColumn = (data, colIndex, startRow) => {
        return data.slice(startRow).reduce((sum, row) => {
            const value = parseFloat(row[colIndex]);
            return sum + (isNaN(value) ? 0 : value);
        }, 0);
    };

    // ✅ 특정 행부터 특정 열(들)의 합계를 구하는 헬퍼 함수(구매카드/해외카드)
    const sumVisibleRowsByCols = (worksheet, startRow, colLetters = ['P', 'Q', 'R', 'S']) => {
        let total = 0;

        // 시트 범위 끝행 구하기
        const ref = worksheet['!ref'];
        if (!ref) return 0;

        const endRowMatch = ref.split(':')[1].match(/(\d+)$/);
        if (!endRowMatch) return 0;

        const endRow = parseInt(endRowMatch[1], 10);

        // hidden row 정보 (엑셀 필터로 숨긴 행 포함될 수 있음)
        const rowMeta = worksheet['!rows'] || [];

        for (let r = startRow; r <= endRow; r++) {
            const rowIndex0 = r - 1; // !rows는 0-based

            // ✅ 숨겨진 행이면 스킵 (필터로 숨긴 행도 hidden 처리되는 케이스 많음)
            if (rowMeta[rowIndex0]?.hidden) continue;

            for (const col of colLetters) {
                const cell = worksheet[`${col}${r}`];
                if (!cell || cell.v == null || cell.v === '') continue;

                // 숫자/문자 모두 안전 파싱
                const num = Number(String(cell.v).replace(/,/g, '').trim());
                if (!Number.isNaN(num)) total += num;
            }
        }

        return total;
    };

    // 구매일지 파싱 및 합산
    const calculateOrderLogFromWorkbook = (workbook, startDateStr, endDateStr) => {
        let newTransferFee = 0;
        let newDomesticFee = 0;
        let newOfflineFee = 0;
        let domesticOrderCardSum = 0;

        // 1. 날짜 범위 계산 (YYYYMM 형태로 변환)
        // 예: "20251018" -> 202510 (숫자)
        const startYM = parseInt(String(startDateStr).substring(0, 6), 10);
        const endYM = parseInt(String(endDateStr).substring(0, 6), 10);

        console.log(`[집계 시작] 설정 기간: ${startYM} ~ ${endYM}`);

        // 정규식 설정
        // 시트 이름용: "구매일지(25년 1월)", "구매일지(25년12월)" 등 공백 유연하게 대응
        const sheetNameRegex = /구매일지\s*\((\d{2})년\s*(\d{1,2})월\)/;

        // 수수료 파싱용
        const feeRegex = /7%\s*\(=([\d,]+)원\)/;
        const offlineRegex = /(약국|오프라인)\s*([\d,]+)(원)?|([\d,]+)\s*(원)?\s*(약국|오프라인)/;

        // 2. 시트 순회 및 필터링
        workbook.SheetNames.forEach(sheetName => {
            // 시트 이름 파싱
            const matchSheet = sheetName.match(sheetNameRegex);

            // "구매일지(xx년 x월)" 형식이 아닌 시트는 무조건 패스
            if (!matchSheet) return;

            // 시트의 연도와 월 추출 (25 -> 2025, 1 -> 01)
            const sheetYear = 2000 + parseInt(matchSheet[1], 10);
            const sheetMonth = parseInt(matchSheet[2], 10);

            // 비교를 위해 YYYYMM 숫자로 변환 (예: 202501, 202512)
            // month가 1자리일 수도 있으니 단순히 합치기보다 수식 계산이 안전
            const sheetYM = (sheetYear * 100) + sheetMonth;

            // 3. 기간 체크: 설정된 기간 범위 밖이면 건너뜀
            if (sheetYM < startYM || sheetYM > endYM) {
                return;
            }

            console.log(`[포함된 시트] "${sheetName}" (코드: ${sheetYM}) - 집계 진행`);

            // ----------------------------------------------------------
            // 여기서부터는 기존 로직과 동일 (해당 시트 데이터 파싱)
            // ----------------------------------------------------------
            const worksheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            data.forEach(row => {
                if (row.length === 0) return;

                // 데이터 정제
                const typeCol = String(row[3] || '').trim(); // D열
                const colC = String(row[2] || '').replace(/,/g, ''); // C열
                const colE = String(row[4] || ''); // E열
                const colF = String(row[5] || ''); // F열

                // ① 국내배송일 때만 E~F 7% 금액 합산
                if (typeCol === '국내배송') {
                    const numC = parseFloat(colC);
                    if (!isNaN(numC)) {
                        domesticOrderCardSum += numC;
                    }

                    const matchE = colE.match(feeRegex);
                    const matchF = colF.match(feeRegex);

                    if (matchE) newDomesticFee += parseInt(matchE[1].replace(/,/g, ''), 10) || 0;
                    if (matchF) newDomesticFee += parseInt(matchF[1].replace(/,/g, ''), 10) || 0;
                }

                // ② 이체대행 & 결제대행 7% 수수료
                if (typeCol === '이체대행' || typeCol === '결제대행') {
                    const matchE = colE.match(feeRegex);
                    const matchF = colF.match(feeRegex);

                    if (matchE) newTransferFee += parseInt(matchE[1].replace(/,/g, ''), 10) || 0;
                    if (matchF) newTransferFee += parseInt(matchF[1].replace(/,/g, ''), 10) || 0;
                }

                // ③ 오프라인/약국
                [colE, colF].forEach(cell => {
                    const match = cell.match(offlineRegex);
                    if (match) {
                        const amountStr = match[2] || match[4];
                        if (amountStr) {
                            const cleanAmount = parseInt(amountStr.replace(/,/g, ''), 10);
                            if (!isNaN(cleanAmount)) newOfflineFee += cleanAmount;
                        }
                    }
                });
            });
        });

        return {
            newTransferFee,
            newDomesticFee,
            newOfflineFee,
            domesticOrderCardSum
        };
    };

    const handleSPackQyChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setSPackQy(value);
        setSPackFee(isNaN(value) ? 0 : value * 5000);
    };

    const [generationBtShow, setGenerationBtShow] = useState(false);
    const [generationBtLoading, setGenerationBtLoading] = useState(false);
    const [generationBtDisabled, setGenerationBtDisabled] = useState(false);

    useEffect(() => {
        if (emsFile && emsPaybackFile && fedexFile && orderCardFile && overCardFile && orderLogFile) {
            setGenerationBtShow(true);
        } else {
            setGenerationBtShow(false);
        }
    }, [emsFile, emsPaybackFile, fedexFile, orderCardFile, overCardFile, orderLogFile]);

    const [generateFailMsg, setGenerationFailMsg] = useState(false);
    const closeGenerateFailMsg = () => {
        setGenerationFailMsg(false);
    }


    const generateFile = async () => {
        setGenerationBtLoading(true);
        setGenerationBtDisabled(true);

        try {
            const workbook = new ExcelJS.Workbook();

            // --- First Tab (신고서 양식) Generation ---
            const getQuarterInfo = () => {
                const startMonth = parseInt(formattedStartDate.substring(4, 6), 10);
                const year = formattedStartDate.substring(2, 4);
                let quarter = 'x분기';
                if (startMonth >= 1 && startMonth <= 3) quarter = '1분기';
                else if (startMonth >= 4 && startMonth <= 6) quarter = '2분기';
                else if (startMonth >= 7 && startMonth <= 9) quarter = '3분기';
                else if (startMonth >= 10 && startMonth <= 12) quarter = '4분기';
                return { year, quarter };
            };

            const { year, quarter } = getQuarterInfo();
            const firstSheetName = `${year}년도 ${quarter}`;
            const finalFileName = `[비토리지 부가세신고 ${year}년 ${quarter}].xlsx`;
            const worksheet = workbook.addWorksheet(firstSheetName);

            const valF11 = (ttOrderCardPrice - ttDomesticOrderCardPrice) || 0;
            const valF12 = (emsFee || 0) + (offlineFee || 0) + (sPackFee || 0) + (seaFee || 0) + (fedexFee || 0) +
                (upsFee || 0) + (deliveryFee || 0) + (repackFee || 0) + (agencyFee || 0) + (comprFee || 0) + (etcFee || 0);
            const valF13 = ttDomesticOrderCardPrice || 0;
            const valF14 = domesticFee || 0;
            const valF15 = ttDomesticFee || 0;
            const valF16 = transferFee || 0;

            const aoa = [
                [],
                ['비토리지'],
                [],
                ['매출성격', null, '배송', null, '매출인식', '수수료발생', '첨부서류', '매입'],
                ['구매대행', '고객이 원하는 사이트에\nURL 접속해서 구매 후 배송까지', '해외배송', null, '①카드매입 액 (국내배송을 뺀 금액)-수출', '②직접 발송건에 대해 건별로 발생(사업장집계)-수출', '우체국 소포수령증 / FedEx / UPS', '상품구입카드'],
                [null, null, '국내배송', null, '③상품구매+수수료:(사업장에서 매출집계)-과세', '7% (국내배송 상품구입액+수수료 :사업장에서 집계)', '없음', null],
                ['배송대행', '배대지역할에 대한 수수료있음.', '해외배송', null, '②에 집계+ _과세(무시)', '건당2천원~', '없음', '없음'],
                [null, null, '국내배송', null, '④수수료-과세', '7% (사업장에서 집계)', null, null],
                ['결제대행', '해외에서->국내송금>쇼핑몰송금(판매자)', '없음', null, '⑤100%계좌이체 수수료매출만 발생함.-과세', '7% (사업장에서 집계)', '없음', '없음'],
                [],
                ['업체준비(필수) -', null, '①', '구매대행 해외배송분 구매비(수출)', null, valF11, '신용카드 물건 구매액 - 국내발송용 상품구매비'],
                [null, null, '②', '해외배송수수료(엘패밀리가 발송하러 이동하는경우발생)(수출)', null, valF12, '사업장 집계', '선편, 재포장수수료, FedEX수수료, UPS수수료, 오프라인 등 기타수수료 총집계(결제대행제외), +거래처 수익은 부가세때', null],
                [null, null, '③', '구매대행 국내발송용 상품 구매비(과세)', null, valF13, '사업장 집계 - 카드매입액을 뺄 수가 없어서 매출/매입 동시인식'],
                [null, null, '③', '구매대행 국내배송분 수수료 (과세)', null, valF14, '사업장 집계'],
                [null, null, '④', '배송대행 국내배송분 수수료 (과세)', null, valF15, '사업장 집계'],
                [null, null, '⑤', '결제대행 수수료 (과세)', null, valF16, '사업장 집계'],
                [],
                ['현금영수증 발행내역'],
                [null],
                [],
                ['특이사항'],
                [null]
            ];

            const thinBorder = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            aoa.forEach((rowData, rIdx) => {
                const row = worksheet.addRow(rowData);
                row.eachCell({ includeEmpty: true }, (cell, cIdx) => {
                    if (cell.value) {
                        cell.border = thinBorder;
                    }
                    cell.font = { name: 'Arial', size: 9 };
                    cell.alignment = { vertical: 'middle', wrapText: true };
                    if (cIdx === 6 && rIdx >= 10 && rIdx <= 15) {
                        cell.numFmt = '#,##0"원"';
                        cell.alignment.horizontal = 'right';
                    }
                });
            });

            const merges = ['A2:B2', 'A4:B4', 'C4:D4', 'C5:D5', 'C6:D6', 'H5:H6', 'C7:D7', 'C8:D8', 'G7:G8', 'H7:H8', 'C9:D9', 'A11:B16', 'D11:E11', 'D12:E12', 'D13:E13', 'D14:E14', 'D15:E15', 'D16:E16', 'A5:A6', 'A7:A8', 'A18:A19', 'A21:A22', 'B5:B6', 'B7:B8'];
            merges.forEach(merge => worksheet.mergeCells(merge));

            // ==========================================================
            // 마지막 수정: H열 너비를 원래대로 복구 (20)
            worksheet.columns = [{ width: 15 }, { width: 22 }, { width: 12 }, { width: 12 }, { width: 25 }, { width: 25 }, { width: 30 }, { width: 20 }, { width: 80 }];
            // ==========================================================

            for(let i = 1; i <= 22; i++) { worksheet.getRow(i).height = 18.75; }
            worksheet.getRow(2).height = 30;
            worksheet.getRow(5).height = 40;

            // 특정 행들 높이 2배로 설정
            [6, 7, 8, 9, 11, 13].forEach(rIdx => {
                worksheet.getRow(rIdx).height = 37.5;
            });

            // ==========================================================
            // 마지막 수정: 12행의 높이만 3배로 설정
            worksheet.getRow(12).height = 18.75 * 3; // 56.25
            // ==========================================================

            const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
            const centerAlignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            worksheet.getCell('A2').fill = headerFill;
            worksheet.getCell('A2').font = { name: 'Arial', size: 11, bold: true };
            worksheet.getCell('A2').alignment = centerAlignment;
            ['A', 'C', 'E', 'F', 'G', 'H'].forEach(col => {
                const cell = worksheet.getCell(`${col}4`);
                cell.fill = headerFill;
                cell.font = { name: 'Arial', size: 11, bold: true };
                cell.alignment = centerAlignment;
            });
            const cellsToCenter = ['A5','A7','B5','B7','C5','C6','C7','C8','C9','G7','H5','H7', 'G6', 'A9', 'G9', 'H9', 'A11'];
            cellsToCenter.forEach(addr => {
                worksheet.getCell(addr).alignment = centerAlignment;
            });

            worksheet.getCell('H12').border = {};

            // --- Other Tabs (첨부파일) Generation ---
            const filesToProcess = [
                { file: emsFile,        name: '우체국 소포수령증' },
                { file: emsPaybackFile, name: '우체국 페이백' },
                { file: fedexFile,      name: 'FedEx 내역서' },
                { file: upsFile,        name: 'UPS 내역서' },
                { file: orderCardFile,  name: '구매 카드내역' },
                { file: overCardFile,   name: '해외비용 카드내역' },
                { file: usePointFile,   name: '적립금 사용내역' }
            ];

            for (const item of filesToProcess) {
                if (item.file) {
                    try {
                        const buffer = await item.file.arrayBuffer();
                        const tempReadWorkbook = XLSX.read(buffer, { type: 'buffer' });
                        const firstSheetName = tempReadWorkbook.SheetNames[0];
                        if (!firstSheetName) {
                            console.warn(`File "${item.name}" has no sheets.`);
                            workbook.addWorksheet(item.name);
                            continue;
                        }
                        const tempSheet = tempReadWorkbook.Sheets[firstSheetName];
                        const data = XLSX.utils.sheet_to_json(tempSheet, { header: 1 });
                        const newSheet = workbook.addWorksheet(item.name);
                        newSheet.addRows(data);

                        if (item.name === '우체국 페이백') {
                            const lastRowIndex = newSheet.rowCount;
                            newSheet.addRow([]);
                            const totalRow = newSheet.addRow(['총금액', emsFee]);
                            totalRow.height = 26.25;
                            const labelCell = totalRow.getCell(1);
                            labelCell.font = { size: 13 };
                            labelCell.alignment = { vertical: 'middle', horizontal: 'center' };
                            const valueCell = totalRow.getCell(2);
                            valueCell.font = { size: 13 };
                            valueCell.alignment = { vertical: 'middle', horizontal: 'center' };
                            valueCell.numFmt = '#,##0';
                            newSheet.mergeCells(lastRowIndex + 2, 2, lastRowIndex + 2, 3);
                        }

                        if (item.name === '적립금 사용내역') {
                            newSheet.getColumn('A').width = 10;
                            newSheet.getColumn('B').width = 20;
                            newSheet.getColumn('C').width = 20;
                            newSheet.getColumn('D').width = 10;
                            newSheet.getColumn('E').width = 20;

                            newSheet.eachRow(row => {
                                for (let i = 1; i <= 5; i++) {
                                    const cell = row.getCell(i);
                                    if(cell.value) {
                                        cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                    }
                                }
                            });
                        }

                    } catch (e) {
                        console.error(`Error processing file "${item.name}":`, e);
                        workbook.addWorksheet(`${item.name} (오류)`);
                    }
                }
            }

            // --- 최종 파일 생성 및 다운로드 ---
            const finalBuffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([finalBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, finalFileName);

        } catch (error) {
            console.error("Failed to generate Excel file:", error);
            setGenerationFailMsg(true);
        } finally {
            setGenerationBtLoading(false);
            setGenerationBtDisabled(false);
        }
    };









    /** endregion */

    return (
        <div className="AdminPageSetPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">세금신고관리</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <div className="pg-set-categories font-t-title font-s-17 m-b-10">
                        <div className={tab === "VAT" ? "pg-set-active-category" : ""}
                             onClick={() => handleCategoryClick("VAT")}>부가세
                        </div>
                        <div className={tab === "CT" ? "pg-set-active-category" : ""}
                             onClick={() => handleCategoryClick("CT")}>법인세
                        </div>
                    </div>
                    <div className="pg-set-tab-content font-t-cont">
                        {/*부가세*/}
                        {tab === "VAT" &&
                            <div className="banner-info-container">
                                <div className="admin-wrap-card">

                                    {/*날짜 & 데이터조회 버튼영역*/}
                                    <div className="display-flex align-center m-b-30">
                                        <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                                       endHandle={endHandle}/>
                                        {/*데이터조회 버튼*/}
                                        <div className="admin-event-wrap-btn">
                                            <style>
                                                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                            </style>
                                            <button onClick={selectedTaxData} disabled={selectedBtDisabled}
                                                    className="user-center admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">
                                                {selectedBtLoading ? (
                                                    <div className="orangeSpinner"></div>
                                                ) : (
                                                    "데이터조회"
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    {/*pt1Data 출력영역*/}
                                    {pt1DataPrint && pt1Data &&
                                        <div>
                                            <div className="modal-body">
                                                {/* ✅ 수정된 부분: 테이블을 감싸는 스크롤 컨테이너 추가 */}
                                                <div className="table-container">
                                                    <table className="tax-table">
                                                        <thead>
                                                        <tr>
                                                            <th style={{width: '5%'}}></th>
                                                            <th style={{width: '25%'}}>박스번호</th>
                                                            <th style={{width: '15%'}}>성함</th>
                                                            <th style={{width: '15%'}}>배송사</th>
                                                            <th style={{width: '15%'}}>총배송료</th>
                                                            <th style={{width: '20%'}}>운송장번호</th>
                                                        </tr>
                                                        </thead>
                                                        {/* ✅ 수정된 부분: tbody에서 클래스 제거 */}
                                                        <tbody>
                                                        {pt1Data && pt1Data.map((item, index) => (
                                                            <tr key={item.seqNum || index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.orderdtDTO.orderNumber + "-" + item.shipInfoDTO.boxNum}</td>
                                                                <td>{item.orderdtDTO.regNm}</td>
                                                                <td>{convertToShipco(item.dvType)}</td>
                                                                <td>{item.ttShipExpense?.toLocaleString()}원</td>
                                                                <td>{item.shipInfoDTO.outWayNum}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    }


                                    <>
                                        {/* 공통 숨김 파일 업로드 input */}
                                        <input
                                            type="file"
                                            accept=".xlsx,.xls"
                                            ref={fileInputRef}
                                            hidden
                                            onChange={handleFileChange}
                                        />

                                        {/*업로드 대시보드*/}
                                        {uploadFormShow && (
                                            <div className="dashboard-container">

                                                {/* Board 1: EMS 소포수령증 */}
                                                <div className="dashboard-board font-s-14"
                                                     onClick={() => handleDashboardClick('EMS_BILL')}>
                                                    <p className="font-s-16 fw-bolder">EMS 소포수령증</p>
                                                    <div className="dashboard-content">
                                                        {emsUploadShow ? (
                                                            <div className="upload-result">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "12px"}}
                                                                >
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 금액</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {ttEmsFilePrice.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{emsFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img  onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("EMS_BILL");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                            <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 2: EMS 페이백 */}
                                                <div className="dashboard-board font-s-14"
                                                     onClick={() => handleDashboardClick('EMS_PAYBACK')}>
                                                    <p className="font-s-16 fw-bolder">EMS 페이백</p>
                                                    <div className="dashboard-content">
                                                        {emsPaybackUploadShow ? (
                                                            <div className="upload-result">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "12px"}}
                                                                >
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 금액</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {emsFee.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{emsPaybackFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("EMS_PAYBACK");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 3: FedEx 청구서 */}
                                                <div className="dashboard-board font-s-14"
                                                     onClick={() => handleDashboardClick('FEDEX_BILL')}>
                                                    <p className="font-s-16 fw-bolder">FedEx 청구서</p>
                                                    <div className="dashboard-content">
                                                        {fedexUploadShow ? (
                                                            <div className="upload-result">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "12px"}}
                                                                >
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 금액</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {ttFedexFilePrice.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 수수료</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {fedexFee.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{fedexFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("FEDEX_BILL");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 4: UPS 청구서 */}
                                                <div className="dashboard-board font-s-14"
                                                     onClick={() => handleDashboardClick('UPS_BILL')}>
                                                    <p className="font-s-16 fw-bolder">UPS 청구서</p>
                                                    <div className="dashboard-content">
                                                        {upsUploadShow ? (
                                                            <div className="upload-result">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "12px"}}
                                                                >
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 금액</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {ttUpsFilePrice.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 수수료</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {upsFee.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{upsFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("UPS_BILL");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 5: 구매카드 내역서 */}
                                                <div className="dashboard-board font-s-14"
                                                     onClick={() => handleDashboardClick('ORDER_CARD')}>
                                                    <p className="font-s-16 fw-bolder">구매카드 내역서</p>
                                                    <div className="dashboard-content">
                                                        {orderCardUploadShow ? (
                                                            <div className="upload-result">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "12px"}}
                                                                >
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 금액</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {ttOrderCardPrice.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{orderCardFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("ORDER_CARD");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 6: 해외카드 내역서 */}
                                                <div className="dashboard-board font-s-14"
                                                     onClick={() => handleDashboardClick('OVER_CARD')}>
                                                    <p className="font-s-16 fw-bolder">해외카드 내역서</p>
                                                    <div className="dashboard-content">
                                                        {overCardUploadShow ? (
                                                            <div className="upload-result">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "12px"}}
                                                                >
                                                                    <div
                                                                        className="display-flex flex-column m-t-10">
                                                                        <p>총 금액</p>
                                                                        <p className="total-price"
                                                                           style={{color: "#4B89DC"}}>
                                                                            {ttOverCardPrice.toLocaleString()} 원
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{overCardFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("OVER_CARD");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 7: 구매일지 */}
                                                <div className="dashboard-board"
                                                     onClick={() => handleDashboardClick('ORDER_LOG')}>
                                                    <p className="font-s-16 fw-bolder">구매일지(수수료)</p>
                                                    <div className="dashboard-content">
                                                        {orderLogUploadShow ? (
                                                            <div className="upload-result multi-line font-s-14">
                                                                <div
                                                                    className="display-flex flex-column justify-content-between"
                                                                    style={{height: "100%", gap: "8px"}}
                                                                >
                                                                    <div className="m-t-10">
                                                                        <div
                                                                            className="display-flex align-center justify-content-between">
                                                                            <p>오프:</p>
                                                                            <p style={{color: "#4B89DC"}}>{offlineFee.toLocaleString()}원</p>
                                                                        </div>
                                                                        <div
                                                                            className="display-flex align-center justify-content-between">
                                                                            <p>이체:</p>
                                                                            <p style={{color: "#4B89DC"}}>{transferFee.toLocaleString()}원</p>
                                                                        </div>
                                                                        <div
                                                                            className="display-flex align-center justify-content-between">
                                                                            <p>국내:</p>
                                                                            <p style={{color: "#4B89DC"}}>{domesticFee.toLocaleString()}원</p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="display-flex align-center justify-content-between">
                                                                        <p className="file-name">{orderLogFile?.name}</p>
                                                                    </div>
                                                                </div>
                                                                <img onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    clearUploadForm("ORDER_LOG");
                                                                }} className="wd-25 ht-25 opa06 c-point m-t-10"
                                                                     src={commonClose} alt="Close"/>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="user-center">
                                                                    <Lottie animationData={taxExcel} loop autoplay
                                                                            className="opa06 wd-90 ht-90"/>
                                                                </div>
                                                                <p className="click-me">Click Me !</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Board 8: 선편 & 항공소형 입력 */}
                                                <div className="dashboard-board input-board">
                                                    <p className="font-s-15 fw-bolder">선편 & 항공소형</p>
                                                    <input
                                                        type="text"
                                                        className="trendy-input"
                                                        placeholder="선편수수료"
                                                        value={seaFee.toLocaleString()} // toLocaleString()이 더 간단하고 안전
                                                        onChange={(e) => {
                                                            // 화면에는 쉼표 포함한 String
                                                            const numericValue = e.target.value.replace(/,/g, '');
                                                            // 실제 상태값에는 Number로 저장
                                                            setSeaFee(Number(numericValue) || 0);
                                                        }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="trendy-input"
                                                        placeholder="소형개수"
                                                        value={sPackQy}
                                                        onChange={handleSPackQyChange}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </>

                                    {generationBtShow &&
                                        <div className="user-center" style={{margin: "20px 0"}}>
                                            <button onClick={generateFile}
                                                    className="filter-complete-btn wd-100 ht-45 user-center" style={{padding:"0"}}>
                                            {generationBtLoading ? (
                                                <div className="spinner"></div>
                                            ) : (
                                                "신고서생성"
                                            )}
                                        </button>
                                    </div>
                                    }

                                </div>
                            </div>
                        }

                        {/*법인세*/}
                        {tab === "CT" &&
                            <div className="banner-info-container">
                                <div className="admin-wrap-card">

                                <div className="display-flex align-center">
                                        <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                                       endHandle={endHandle}/>
                                        {/*데이터조회 버튼*/}
                                        <div className="admin-event-wrap-btn">
                                            <style>
                                                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                            </style>
                                            <button disabled={selectedBtDisabled}
                                                    className="user-center admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">
                                                {selectedBtLoading ? (
                                                    <div className="orangeSpinner"></div>
                                                ) : (
                                                    "데이터조회"
                                                )}
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        }

                    </div>


                </div>
            </div>


            { pt1DataShow ?
                <AdminTaxListModal pt1DataShow={pt1DataShow} pt1Data={pt1Data} closePt1DataPopup={closePt1DataPopup}
                                   completeFilter={completeFilter}/>
                :
                nonData ?
                    <MsgCheckModal nonData={nonData} closeNonDataPopup={closeNonDataPopup}/>
                    :
                    fedexUnMatchShow ?
                        <AdminTaxListModal
                            fedexUnMatchShow={fedexUnMatchShow}
                            fedexUnMatchList={fedexUnMatchList}
                            fedexFileWaybillList={fedexFileWaybillList}
                            fedexFileAmountList={fedexFileAmountList}
                            closeFedexUnMatchShow={closeFedexUnMatchShow}
                            pt1Data={pt1Data}
                        />
                        :
                        upsUnMatchShow ?
                        <AdminTaxListModal
                            upsUnMatchShow={upsUnMatchShow}
                            upsUnMatchList={upsUnMatchList}
                            upsFileWaybillList={upsFileWaybillList}
                            upsFileAmountList={upsFileAmountList}
                            closeUpsUnMatchShow={closeUpsUnMatchShow}
                            pt1Data={pt1Data}
                        />
                        :
                            generateFailMsg ?
                                <MsgCheckModal generateFailMsg={generateFailMsg} closeGenerateFailMsg={closeGenerateFailMsg}/>
                                :
                                null
            }

        </div>
    );
}

export default AdminTaxPg
